
const inactivityTimeOut = (6 * 60 * 60 * 1000);         // 06 h
const inactivityCountdown = (30);                       // 30 s
const coockieTimeOut = (6 * 60 * 60 * 1000);            // 06 h

const defaultQuota = '0';
const ordinaryQuota = '10';
const donationMagazineQuota = '10';

const previousYear = new Date().getFullYear()-1;
const displayYear = new Date().getFullYear();

const emailURI = 'https://europaverde.it';
const auTokenName = 'APP-UNIQUE-TOKEN';
//const authKey = 'signedIn';


const emailHERO = 'dante.mei@arimaslab.com';
const emailADMIN = 'dante.mei@arimaslab.com';

const defaultNONE = 'NONE';
const defaultNO = 'NO';
const defaultYES = 'SI';
const defaultINTPHONECODE = '+39';
const defaultEMPTY = '';
const defaultOTPPSW = 'OTP!LogIn';

const defaultAPPTITLE = 'Tesseramento Europa Verde';
const defaultAPPLOGO = 'img/europaverde.png';
const defaultREQUIRED = ' *';

const defaultMomentDateFormat = 'DD/MM/YYYY';

const defaultMinYoungAge = 27;
const defaultMinYoungYear = 1998;

const authLocalStorage = {
    authKey: 'signedIn',
    userData: []
}

const stockStorage = {
    stockToken: 'stockToken',
    stockData: [],

    sessionStock: 'sessionStock',
    newSessionStock: 'newSessionStock',
    sessionStockRegion: 'sessionStockRegion',
    sessionStockProvince: 'sessionStockProvince',
    sessionStockPromoter: 'sessionStockPromoter',
}

const emailStorage = {
    emailSent: 'emailSent'
}

const systemParamenters = {
    status: {
        open: 'STATUS_OPEN',
        closed: 'STATUS_CLOSED',
        deleted: 'STATUS_DELETED',
    }
}
const defaultRoleRegionProvinceTown = false;
const closed = false;
const maintenanceMode = false;

/*
1.8.20240916
1.9.20241003
1.10.20241003
1.11.20241003
1.12.20241016
1.13.20241024
1.14.20241029
1.15.20241029
1.16.20241119
1.17.20241125
1.18.20241209
1.19.20241209
1.20.20241209
1.21.20241209
1.22.20250115 | 1.23.20250115 | 1.24.20250115
1.25.20252903 | 1.26.20252903
1.27.20253103a | 1.28.20253103
1.29.20253103
1.30.20250519
1.37.20251030
1.39.20251103
1.41.20260430
1.42.20260504
1.43.20260623
*/

const appVersion = '1.44.20260624';
const currentAppLocale = document.documentElement.lang;
//const emailPattern = '/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/';
const emailPattern = new RegExp(
  '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
);

export {
    inactivityTimeOut,
    inactivityCountdown,
    coockieTimeOut,
    defaultQuota,
    previousYear,
    displayYear,
    emailURI,

    authLocalStorage,
    auTokenName,

    systemParamenters,
    emailStorage,
    emailHERO,
    emailADMIN,
    defaultNONE,

    stockStorage,

    defaultNO,
    defaultYES,
    defaultINTPHONECODE,
    defaultEMPTY,
    defaultAPPTITLE,
    defaultAPPLOGO,
    defaultREQUIRED,
    defaultOTPPSW,

    defaultRoleRegionProvinceTown,
    ordinaryQuota,

    closed,
    maintenanceMode,
    donationMagazineQuota,
    defaultMomentDateFormat,

    appVersion,

    defaultMinYoungAge,
    defaultMinYoungYear,
    currentAppLocale,
    emailPattern,
};
